var map = {
	"./Kentico.svg": 39906,
	"./Kontent.svg": 1756,
	"./Strapi.svg": 64330,
	"./about-skating-butler.svg": 87339,
	"./amazon.svg": 80309,
	"./atom.svg": 40206,
	"./backgrounds/background-line-arrow-head.svg": 36321,
	"./backgrounds/background-line.svg": 35858,
	"./backgrounds/cloud-dots-bottom.svg": 79837,
	"./backgrounds/cloud-dots-top.svg": 28341,
	"./backgrounds/cloud-page_header-dots-a.svg": 90909,
	"./backgrounds/cloud-page_header-dots-b.svg": 36734,
	"./backgrounds/cloud-page_header-dots-c.svg": 99311,
	"./backgrounds/cloud-page_proof-arrow.svg": 50445,
	"./backgrounds/cloud-page_proof-watermark.svg": 43192,
	"./backgrounds/concierge-form-bg-left-bottom.svg": 78787,
	"./backgrounds/concierge-form-bg-left-center.svg": 19629,
	"./backgrounds/concierge-form-bg-right-center.svg": 19442,
	"./backgrounds/concierge-page_header-a.svg": 22798,
	"./backgrounds/concierge-page_header-b.svg": 17165,
	"./backgrounds/concierge-page_header-c.svg": 81708,
	"./backgrounds/cta-block-hands-a.svg": 24940,
	"./backgrounds/cta-block-hands-b.svg": 80287,
	"./backgrounds/cta-block-hands-c.svg": 75534,
	"./backgrounds/home_dots.svg": 49921,
	"./ball-being-rolled.svg": 33087,
	"./bg-home.svg": 4608,
	"./checkmark.svg": 88496,
	"./codesandbox.svg": 55071,
	"./color-blocks.svg": 97913,
	"./concierge-account-management.svg": 37616,
	"./concierge-audit.svg": 89872,
	"./concierge-review.svg": 46003,
	"./concierge-slack-channel.svg": 747,
	"./concierge-ticket-prioritization.svg": 49205,
	"./concierge-training.svg": 60941,
	"./contentful.svg": 65853,
	"./contentstack.svg": 40508,
	"./datocms.svg": 49670,
	"./diagram/cdn-mini.svg": 28692,
	"./diagram/cdn-new.svg": 32913,
	"./diagram/cdn.svg": 37340,
	"./diagram/cli-big.svg": 51934,
	"./diagram/cli-mini.svg": 23089,
	"./diagram/cms-big.svg": 91,
	"./diagram/cms-documents.svg": 64071,
	"./diagram/cms-mini.svg": 75710,
	"./diagram/cms.svg": 46542,
	"./diagram/code-documents.svg": 24749,
	"./diagram/content-creator.svg": 17749,
	"./diagram/database.svg": 59056,
	"./diagram/developer.svg": 64879,
	"./diagram/filesystem.svg": 3870,
	"./diagram/react.svg": 37348,
	"./diagram/user-new-small.svg": 30585,
	"./diagram/user-new.svg": 13547,
	"./diagram/user.svg": 84614,
	"./docs-keyvisual-conceptual-guides.svg": 79857,
	"./docs-keyvisual-homepage.svg": 66627,
	"./docs-keyvisual-how-to-guides.svg": 91819,
	"./docs-keyvisual-reference-guides.svg": 77244,
	"./docs-keyvisual-tutorials.svg": 99728,
	"./drupal.svg": 46055,
	"./gatsby-days-logo.svg": 91813,
	"./guides-astronaut-butler.svg": 14475,
	"./guides-markdown.svg": 54312,
	"./guides-react-hero-bottom.svg": 4459,
	"./guides-react.svg": 74360,
	"./guides-stars.svg": 77958,
	"./hand-dropping-ball.svg": 90378,
	"./hosting.svg": 50785,
	"./icon-apps.svg": 74255,
	"./icon-data.svg": 40327,
	"./icon-deployment.svg": 6258,
	"./icon-link.svg": 70699,
	"./icon-performance.svg": 13767,
	"./icons/article.svg": 85818,
	"./icons/md-arrow-forward.svg": 8571,
	"./integrations-circle.svg": 49181,
	"./integrations-hexagon.svg": 12079,
	"./integrations-polygon.svg": 94789,
	"./integrations-two-squares.svg": 57230,
	"./jekyll.svg": 19258,
	"./light-purple-dot.svg": 34896,
	"./logo.svg": 92564,
	"./markdown.svg": 87146,
	"./monogram.svg": 80613,
	"./netlify-grayscale.svg": 99626,
	"./netlify.svg": 75072,
	"./nextjs.svg": 51875,
	"./pictures/cloud-page_cms-previews-desktop.svg": 30397,
	"./pictures/cloud-page_cms-previews-mobile.svg": 27401,
	"./pictures/cloud-page_deploy-previews-desktop.svg": 80017,
	"./pictures/cloud-page_deploy-previews-mobile.svg": 95653,
	"./pictures/cloud-page_incremental-builds-desktop.svg": 48984,
	"./pictures/cloud-page_incremental-builds-mobile.svg": 20934,
	"./pictures/cloud-page_lighthouse-reports-desktop.svg": 12464,
	"./pictures/cloud-page_lighthouse-reports-mobile.svg": 1198,
	"./pwa.svg": 95595,
	"./pwa_card.svg": 88544,
	"./react.svg": 50762,
	"./sanitize.svg": 37060,
	"./sanity.svg": 20979,
	"./silly-site-award.svg": 85794,
	"./silly-site-background.svg": 68007,
	"./silly-site-challenge-pattern-light.svg": 19052,
	"./silly-site-challenge-pattern.svg": 71679,
	"./silly-site-shapes.svg": 82957,
	"./silly-site-swag.svg": 61941,
	"./source.svg": 47650,
	"./support-cloud-knowledge-base.svg": 17917,
	"./support-form-background.svg": 72278,
	"./support-form-hand.svg": 82221,
	"./support-open-source-docs.svg": 40645,
	"./support-product-roadmap.svg": 35699,
	"./support-status-page.svg": 10643,
	"./use-case-ellipse-2.svg": 23527,
	"./use-case-ellipse.svg": 91310,
	"./use-case-polygon.svg": 50926,
	"./use-case-rectangle.svg": 21619,
	"./why-gatsby-bg-block-1.svg": 57152,
	"./why-gatsby-bg-block-2.svg": 77907,
	"./why-gatsby-blazing-fast-websites.svg": 87374,
	"./why-gatsby-delight-developers.svg": 62058,
	"./why-gatsby-ensure-safety.svg": 25036,
	"./why-gatsby-exceed-expectations.svg": 48721,
	"./why-gatsby-stars.svg": 69890,
	"./why-gatsby-start-quickly.svg": 44702,
	"./wordpress.svg": 54498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65663;